module.exports = __webpack_public_path__ + "img/terms-fill.ac995243.svg";